import { LairStKaiaAbi } from '../abis/lair'
import { TotalSupplyAbi } from '../abis/shared'
import type { LstRegistryEntry } from '../registry'
import { ONE_E18, toBigInt, type LstReader } from './shared'

/**
 * Lair Finance stKAIA reader (Kaia chain 8217).
 *
 * Three calls:
 *   1. `stKAIA.totalSupply()`
 *   2. `stKAIA.getRatio()` — 1e18-scaled KAIA-per-stKAIA rate
 *   3. `stKAIA.totalStaking()` — total KAIA managed (incl. rewards)
 *
 * Share-price model (non-rebasing), same shape as the BENQI sAVAX
 * reader. `getRatio()` equals `totalStaking()/totalSupply()`, so the
 * derived fallback matches the protocol's own `totalStaking()`.
 */
export const readerLairStKaia = (entry: LstRegistryEntry): LstReader => ({
  calls: [
    { address: entry.address, name: 'totalSupply', params: [] },
    { address: entry.address, name: 'getRatio', params: [] },
    { address: entry.address, name: 'totalStaking', params: [] },
  ],
  abis: [TotalSupplyAbi, LairStKaiaAbi, LairStKaiaAbi],
  parse: ([supply, rate, totalStaking]) => {
    const totalSupply = toBigInt(supply)
    const exchangeRate = toBigInt(rate)
    if (totalSupply === undefined || exchangeRate === undefined) {
      return undefined
    }
    const totalAssets =
      toBigInt(totalStaking) ?? (totalSupply * exchangeRate) / ONE_E18
    return {
      totalAssets,
      totalSupply,
      exchangeRate,
    }
  },
})
